import { useCallback, useState } from "react";
import { useGoogleAuth } from "../../hooks/useGoogleAuth";

export const useLogin = () => {
  const [error, setError] = useState<string | null>(null);

  const handleError = useCallback((err: Error) => {
    setError(err.message ?? "Erro no login com Google.");
  }, []);

  const { signIn } = useGoogleAuth({ onError: handleError });

  const login = useCallback(() => {
    setError(null);
    signIn();
  }, [signIn]);

  return { login, error };
};
